import { render } from "./Smart.vue?vue&type=template&id=453fa9c4&scoped=true"
import script from "./Smart.vue?vue&type=script&lang=js"
export * from "./Smart.vue?vue&type=script&lang=js"

import "./Smart.vue?vue&type=style&index=0&id=453fa9c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453fa9c4"]])

export default __exports__